/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'
import url_stringImg from 'assets/images/url-string.jpg'

export const _1 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>1 - Маршрутизация</h2>
    <p className={styles.description}>
      Отличающее преимущество веб-приложения от десктоп это наличие URL, при переходе по которому, пользователь
      оказывается в определенной части приложения. Так можно сохранить закладку или передать ссылку другому
      пользователю, при этом ему будет отображен один и тот же интерфейс (за исключением приватных данных).{' '}
    </p>
    <p className={styles.description}>
      <b>Маршрутизация (routing)</b> - это не побочный эффект при написании приложения, наоборот, грамотную архитектуру
      навигации необходимо продумывать в первую очередь.{' '}
    </p>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>1.1 - Структура URL-строки</h3>
      <p className={styles.description}>
        Аналогией URL-строки может быть адрес по которому вы проживаете: улица, дом, квартира. У каждого состояния
        интерфейса должен быть свой адрес, свой URL. То, что видит пользователь, состояние интерфейса, должно быть
        описано в URL.{' '}
      </p>
      <img className={styles.img} src={url_stringImg} alt="url-string" />
      <ul className={styles.list}>
        <li className={styles.list__item}>
          <code className={styles.code}>https://</code> - протокол
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>mysite.com/</code> - хост
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>books/e3q76gm9lzk</code> - путь, то где мы находимся в приложении
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>e3q76gm9lzk</code> - url-параметр. Параметры бывают динамическими или
          статическими
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>?</code> - символ начала строки запроса
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>?category=adventure&amp;status=unread</code>​ - строка запроса
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>category=adventure</code> - пара параметр=значение
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>&amp;</code> - символ "И", разделяет параметры строки запроса
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>#comments</code> - якорь (хеш), определяет положение на странице
        </li>
      </ul>
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>1.2 - История навигации</h3>
      <p className={styles.description}>
        <b>История навигации</b> - то как мы переходим ссылкам, как переходы хранятся и парсятся. От типа истории
        зависит метод ее хранения и изменения.{' '}
      </p>
      <p className={styles.description}>
        Если вы хотите понять React Router, рекомендуется ознакомиться с{' '}
        <a
          className={styles.link}
          href="https://medium.com/@pshrmn/a-little-bit-of-history-f245306f48dd"
          target="_blank"
          rel="noopener noreferrer"
        >
          HTML5 History API
        </a>
        . Более конкретно, c пакетом{' '}
        <a
          className={styles.link}
          href="https://github.com/ReactTraining/history"
          target="_blank"
          rel="noopener noreferrer"
        >
          history
        </a>
        , который предоставляет основные функциональные возможности для React Router, позволяя одностраничным
        приложениям легко добавлять навигацию на стороне клиента.
      </p>
      <p className={styles.description}>Существует несколько типов истории. </p>
      <ul className={styles.list}>
        <li className={styles.list__item}>
          <b>Browser history</b> - использует HTML5 History API, стандарт управления историей браузера из JavaScript.
        </li>
        <li className={styles.list__item}>
          <b>Hash history</b> - в старых браузерах не поддерживается HTML5 History API, поэтому для них существует эта
          реализация.
        </li>
        <li className={styles.list__item}>
          <b>Memory history</b> - позволяет использовать историю сессии в памяти, вне окна браузера. К примеру для
          тестирования логики без интерфейса и в средах без DOM, к примеру React Native.
        </li>
      </ul>
    </section>
  </section>
))
